import { Component, OnInit } from '@angular/core';
import { EmpleadosServicio } from '../../services/empleado.service';
import { AlertasModales } from '../../helpers/alertasModales';
import { Router } from '@angular/router';

@Component({
  selector: 'app-respaldar',
  templateUrl: './respaldar.component.html',
  styleUrls: ['./respaldar.component.css']
})
export class RespaldarComponent implements OnInit {
  downloadingDb = false;
  downloadingFile = false;
  tipo = 'db';

  constructor(
    private empleadoService: EmpleadosServicio,
    private modals: AlertasModales,
    private router: Router
  ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3) {
      this.router.navigate(['/404']);
    }
  }

  ngOnInit() {
  }

  downloadBackup(tipo: string) {
    this.downloadingDb = tipo == 'db';
    this.downloadingFile = tipo == 'file';
    this.empleadoService.descargarBackup(this.tipo = tipo)
    .subscribe(path => {
      window.open(path, '_blank');
      this.downloadingDb = this.downloadingFile = false;
    }, err => {
      this.modals.validacionesModalJquery('Respaldo fallido', err.error,
      'red',
      'modern',
      false,
      'fa fa-database');
      this.downloadingDb = this.downloadingFile = false;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/respaldar/respaldar.component.ts